// extracted by mini-css-extract-plugin
export default {"page-tests-container":"PageTests_page-tests-container__w+fRG","content-wrap":"PageTests_content-wrap__dk9Je","btn-wrap":"PageTests_btn-wrap__SeeYO"};